const requestComments = {
  toggle: {
    comments: "Athugasemdir ({{count}})",
  },
  errors: {
    loadFailed: "Ekki tókst að sækja athugasemdir",
    addFailed: "Ekki tókst að bæta við athugasemd",
  },
  loading: "Sæki athugasemdir...",
  empty: {
    noComments: "Engar athugasemdir ennþá.",
    startConversation: "Byrjaðu samtalið!",
  },
  role: {
    researcher: "rannsakandi",
    admin: "stjórnandi",
  },
  form: {
    placeholder: "Skrifaðu athugasemd...",
    adding: "Bæti við...",
    addComment: "Bæta við athugasemd",
  },
  disabledNotice:
    "Athugasemdir eru eingöngu í boði fyrir beiðnir sem bíða afgreiðslu eða hafa verið samþykktar.",
};

export default requestComments;
